import React from 'react';
import { STATUS_COLORS } from '../../utils/constants';

// Pastille de statut : teinte douce + point coloré + texte foncé (lisible, pas de blanc sur couleur)
const StatusBadge = ({ status, size = 'sm', className = '' }) => {
  const color = STATUS_COLORS[status] || '#3B82F6';
  const pad = size === 'xs' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap ${pad} ${className}`}
      style={{ backgroundColor: `${color}1F`, color }}
    >
      <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: color }} aria-hidden="true" />
      <span className="text-slate-800">{status}</span>
    </span>
  );
};

export default StatusBadge;
